import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon, FolderPlusIcon } from '@components/common/ui/icons';
import { useSidebarStore, useAuthStore } from '@hooks/useStores';
import { useToastContext } from '@contexts/ToastContext';
import { observer } from 'mobx-react-lite';
import * as styles from '@components/sidebar/FileSidebar.module.css';

const cn = (...classes: (string | undefined | false)[]) => classes.filter(Boolean).join(' ');

export const QuickActions: React.FC = observer(() => {
    const { t } = useTranslation();
    const sidebarStore = useSidebarStore();
    const authStore = useAuthStore();
    const toast = useToastContext();

    const handleCreateNote = () => {
        if (!authStore.user?.isActivated) {
            toast.warning(t('sidebar.activateForNotes'));
            return;
        }
        sidebarStore.startEditing(`temp-note-${Date.now()}`, 'create-note', null);
    };

    const handleCreateFolder = () => {
        if (!authStore.user?.isActivated) {
            toast.warning(t('sidebar.activateForFolders'));
            return;
        }
        sidebarStore.startEditing(`temp-folder-${Date.now()}`, 'create-folder', null);
    };

    return (
        <div className={cn(styles.quickActions, styles.quickActionsRow)}>
            <button
                className={cn(styles.button, styles.buttonDashed)}
                onClick={handleCreateNote}
                title={t('sidebar.newNoteHotkey')}
            >
                <PlusIcon className={styles.icon} />
                <span>{t('sidebar.newNote')}</span>
            </button>

            <button
                className={cn(styles.button, styles.buttonDashed)}
                onClick={handleCreateFolder}
                title={t('sidebar.newFolderTitle')}
            >
                <FolderPlusIcon className={styles.icon} />
                <span>{t('sidebar.newFolder')}</span>
            </button>
        </div>
    );
});
